import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input, InputGroup, Label, InputGroupText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { actions } from '../../../context';
import debounce from 'lodash.debounce';

const FilterSearch = () => {
    const dispatch = useDispatch();

    const updatePracticesListWithFilter = useCallback(
        (string) => dispatch(actions.practice.setFilter(string)),
        [dispatch]
    );

    const changeHandler = (event) => {
        updatePracticesListWithFilter(event.target.value);
    };

    const debouncedChangeHandler = useMemo(
        () => debounce(changeHandler, 400),
        // eslint-disable-next-line
        []
    );

    useEffect(() => {
        return () => {
            debouncedChangeHandler.cancel();
        };
    }, [debouncedChangeHandler]);

    const filterOutput = (e) => {
        e.preventDefault();
        // TODO: turn pagination back on
        // TODO: what does this do?
        dispatch(actions.practice.setCurrentPage(1));
        let sidescroller = document.getElementById('sidescroller');
        sidescroller.scrollTop = 0;
    };

    const focusSearchTextInputField = () =>
        setTimeout(() => document.getElementById('searchBar').focus(), 100);
    const blurSearchTextInputField = () =>
        document.getElementById('searchBar').blur();

    useEffect(() => {
        focusSearchTextInputField();
        return () => {
            blurSearchTextInputField();
            debouncedChangeHandler.cancel();
        };
    }, [debouncedChangeHandler]);

    return (
        <Form
            className="d-flex justify-content-center"
            onSubmit={(e) => filterOutput(e)}>
            <InputGroup className="text-center" id="exampleSearch">
                <Label for="searchBar" className="text-center "></Label>
                <Input
                    sm={8}
                    className="text-center"
                    type="search"
                    name="search"
                    id="searchBar"
                    placeholder="Search"
                    style={{ borderRadius: '0.2rem 0 0 0.2rem' }}
                    onChange={(e) => {
                        e.persist();
                        debouncedChangeHandler(e);
                    }}
                />
                <InputGroupText
                    onClick={(e) => filterOutput(e)}
                    className="bg-white hoverable no-border"
                    style={{ borderRadius: '0 0.2rem 0.2rem 0' }}>
                    <FontAwesomeIcon icon="search" />
                </InputGroupText>
            </InputGroup>
        </Form>
    );
};

export default FilterSearch;
